<template>
  <div class="client">
    <div class="top-header">
      <router-link :to="{ name: 'brands_list' }">
        <v-btn icon>
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </router-link>
      {{ brand.name }}
    </div>

    <div class="py-5 px-8 white">
      <v-tabs v-model="tab" color="#ff9c00">
        <v-tab class="text-capitalize">
          <span class="vlue-tab-span black--text">
            Edit Brand
          </span>
        </v-tab>
        <!--        <v-tab class="text-capitalize">-->
        <!--          <span class="vlue-tab-span black&#45;&#45;text">Cards</span>-->
        <!--        </v-tab>-->
      </v-tabs>
      <v-divider class="my-4 divider-dashed" />
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <EditBrand :brandProp="brand" />
        </v-tab-item>
      </v-tabs-items>
    </div>
  </div>
</template>

<script>
import RestResourceClient from "@/api/apiClientService";
import EditBrand from "./EditBrand";
import RestResourceBrand from "../../api/apiBrandService";
// import ClientOrders from "./ClientOrders";
export default {
  components: { EditBrand },
  data() {
    return {
      brand: {
        name: ""
      },
      tab: null
    };
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      RestResourceBrand.prototype
        .getBrand(this.$route.params.id)
        .then(response => {
          this.brand = response.data;
          console.log(this.brand);
        })
        .catch(error => {
          throw error;
        });
    }
  }
};
</script>

<style>
.client .v-tabs-slider-wrapper {
  height: calc(100% - 10px) !important;
  top: 50%;
  transform: translateY(-50%);
  border: solid 2px var(--cpanel-primary-color);
  border-radius: 7px;
}

.client .v-tabs-slider-wrapper .v-tabs-slider {
  background-color: transparent !important;
}
</style>
